import { useRoutes, Navigate, useLocation } from "react-router-dom";
import {isAuthenticated, hasToken} from './components/auth/sessionStore';
import Account from './components/account';
import Dashboard from './components/dashboard';
import Devices from './components/devices';
import Users from './components/users';
import Logs from './components/logs';
import Policies from './components/policy';
import PolicyAssignments from './components/policy/assignments';
import {SignIn} from './components/auth/signIn';
import {Callback} from './components/auth/callback';
import {SignOut} from "./components/auth/signOut";
import {PrivateRoute} from "./components/auth/privateRoute";
import MainLayout, {Empty as EmptyLayout} from "./components/layout";
import {NotFound} from "./components/notFound";
import Whitelist from "./components/whitelist";
import WhitelistAssignments from "./components/whitelist/whitelistAssignments";
import Subscriptions from "./components/subscriptions";
import SHKeys from "./components/hdm-keys";
import HDMConfig from "./components/hdm-configuration";
import HDMAssignments from "./components/hdm-configuration/hdmAssignments";
import AdminUsers from "./components/admin";
import Roles from "./components/roles";
import Alerts from "./components/messaging";
import AuthedApolloProvider from './components/auth/authedApolloProvider';
//import Form from './components/bulk-operations';
import { AlertsProvider } from './lib/withAlerts';
import {RequirePermission} from './components/auth/requirePermission';
import {Unauthorized} from './components/unauthorized';

const PUBLIC_PATHS = new Set(['/signin', '/callback', '/signout']);

export default function Router() {
  const isUnauthenticated = sessionStorage.getItem('unauthenticated') === 'true';
  const location = useLocation();

  const element = useRoutes([
    {
      element: (
        <AlertsProvider>
          <AuthedApolloProvider>
            <MainLayout />
          </AuthedApolloProvider>
        </AlertsProvider>
      ),
      children: [
        {index: true, path: "/", element: <PrivateRoute element={<Dashboard/>}/>},
        {path: "account", element: <PrivateRoute element={<Account/>} />},
        //{path: "bulk-operations", element: <PrivateRoute element={<Form/>} />},
        {path: "devices", element: <PrivateRoute element={<Devices/>} />},
        {path: "policies", element: <PrivateRoute element={<Policies/>} />},
        {path: "hdm-keys", element: <PrivateRoute element={<SHKeys/>} />},
        {path: "messaging", element: <PrivateRoute element={<Alerts/>} />},
        {path: "admin", element: <PrivateRoute element={<RequirePermission code="CA_VIEW"><AdminUsers/></RequirePermission>} />},
        {path: "roles", element: <PrivateRoute element={<RequirePermission code="ROLE_VIEW"><Roles/></RequirePermission>} />},
        {path: "users", element: <PrivateRoute element={<Users/>} />},
        {path: "logs", element: <PrivateRoute element={<Logs/>} />},
        {path: "hdm-configuration", element: <PrivateRoute element={<HDMConfig/>} />},
        {path: "subscriptions", element: <PrivateRoute element={<Subscriptions/>} />},
        {path: "ssid-whitelist", element: <PrivateRoute element={<Whitelist/>} />},
        {path: "ssid-whitelist/assignments", element: <PrivateRoute element={<WhitelistAssignments />} />},
        {path: "policy/assignments", element: <PrivateRoute element={<PolicyAssignments/>} />},
        {path: "hdm/assignments", element: <PrivateRoute element={<HDMAssignments/>} />},
        {path: "unauthorized", element: <PrivateRoute element={<Unauthorized/>} />},
        {path: "*", element: <PrivateRoute element={<NotFound/>} />},
      ]
    },
    {
      element: <EmptyLayout />,
      children: [
        {path: "signin", element: <SignIn />},
        {path: "callback", element: <Callback /> },
        {path: "signout", element: <SignOut />}
      ]
    }
  ]);

  if (isUnauthenticated) {
    return <SignOut />;
  }

  if (!hasToken() && !PUBLIC_PATHS.has(location.pathname)) {
    return <Navigate to="/signin" replace />;
  }

  return element;
}
